import { EVENT_CODE_LABELS_ES, getEventLabel } from "../../../store/admin/deviceEventsStore";

const OTHER_EVENT_CODE = 43;

export const humanizeEventType = (eventType: string | null | undefined): string => {
  const text = (eventType ?? "").replace(/[_-]+/g, " ").trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};

export const resolveEventLabel = (
  eventCode: number | null | undefined,
  eventType: string | null | undefined,
): string => {
  const humanized = humanizeEventType(eventType);
  if (eventCode === OTHER_EVENT_CODE) return humanized || "Otro";
  const known = eventCode != null && Boolean(EVENT_CODE_LABELS_ES[String(eventCode)]);
  return known || !humanized ? getEventLabel(eventCode ?? null) : humanized;
};
